export default {"src":"/_next/static/media/ask-query.7acc7230.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};